import { GivelifyButton, GivelifyLabel } from '@givelify/ui';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DownloadNow = styled(GivelifyButton)(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        width: '100%',
    },
    flexShrink: 0,
}));

export const DownloadHelp = styled(GivelifyButton)(({ theme }) => ({
    flexShrink: 0,
    width: 270,
    [theme.breakpoints.down('mobile')]: {
        width: '100%',
    },
}));

export const SnapTitle = styled(GivelifyLabel)(({ theme }) => ({
    fontSize: 36,
    lineHeight: '42px',
    [theme.breakpoints.down('mobile')]: {
        fontSize: 24,
        lineHeight: '32px',
    },
}));

export const NeedHelpTitle = styled(GivelifyLabel)(({ theme }) => ({
    fontSize: 28,
    fontWeight: 'bold',
    [theme.breakpoints.down('mobile')]: {
        fontSize: 18,
        fontWeight: 600,
        marginBottom: theme.spacing(2),
    },
}));

export const QrCodeBox = styled(Grid)({
    marginTop: 64,
    display: 'flex',
    justifyContent: 'center',
});

export const Hidden = styled('a')({
    visibility: 'hidden',
    opacity: 0,
});

export const HelpButtonBox = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('mobile')]: {
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
}));
